export const HOURS_PER_MONTH = 730;

export const GB_PER_MB = 1 / 1024;
export const GB_PER_TB = 1024;

export const KB_PER_BYTE = 1 / 1024;
export const KB_PER_MB = 1024;
